import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogTitle,
	Stack,
	Typography,
} from "@mui/material";
import { Iconify } from "@onair/minimal-ui/iconify";
import React from "react";
import LoadingButton from "@mui/lab/LoadingButton";

interface WarningEventDraftDialogProps {
	isDrafting: boolean;
	open: boolean;
	onClose: () => void;
	onDraft: () => void;
}

const WarningEventDraftDialog: React.FC<WarningEventDraftDialogProps> = ({
	isDrafting,
	open,
	onClose,
	onDraft,
}) => {
	return (
		<Dialog
			open={open}
			onClose={onClose}
			maxWidth="xs"
			fullWidth
			scroll="paper"
		>
			<DialogTitle
				display="flex"
				sx={{
					p: 3,
					pr: 2,
					justifyContent: "space-between",
					alignItems: "center",
				}}
			>
				<Stack direction="row" spacing={2}>
					<Iconify icon="solar:inbox-bold" color="primary.main" width={24} />
					<Typography fontWeight={700} variant="h6">
						Lưu nháp sự kiện
					</Typography>
				</Stack>
			</DialogTitle>
			<Box px={3}>
				<Typography variant="body2">
					Bạn có chắc chắn muốn lưu nháp sự kiện này không?
				</Typography>
			</Box>
			<DialogActions>
				<Button
					onClick={onClose}
					variant="outlined"
					color="inherit"
					size="medium"
				>
					Tiếp tục chỉnh sửa
				</Button>
				<LoadingButton
					loading={isDrafting}
					variant="contained"
					color="primary"
					size="medium"
					onClick={onDraft}
				>
					Lưu
				</LoadingButton>
			</DialogActions>
		</Dialog>
	);
};

export default WarningEventDraftDialog;
